import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  Tooltip,
  Stack,
  Alert,
  Chip
} from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, VpnKey as KeyIcon } from '@mui/icons-material';
import LockResetIcon from '@mui/icons-material/LockReset';
import { useAuth } from '../../context/AuthContext';
// TEMPORAIREMENT DÉSACTIVÉ - en attente de migration des utilisateurs
// import { usersDB, techniciansDB } from '../../db/database';
import { USER_ROLES, PERMISSIONS } from '../../types/users';
import PageTitle from '../layout/PageTitle';

const DEFAULT_PASSWORD = 'Orange2024';

const UserRights = () => {
  console.log('UserRights component rendering');
  const { currentUser, hasPermission } = useAuth();
  console.log('Current user:', currentUser);
  const [users, setUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [resetPasswordConfirmDialog, setResetPasswordConfirmDialog] = useState({ open: false, user: null });
  const [newUser, setNewUser] = useState({
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    role: USER_ROLES.VIEWER
  });
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    username: '',
    firstName: '',
    lastName: '',
    email: '',
    role: 'viewer',
    password: ''
  });
  const [error, setError] = useState('');

  // TEMPORAIREMENT DÉSACTIVÉ
  // useEffect(() => {
  //   loadUsers();
  // }, []);

  const loadUsers = async () => {
    try {
      // TEMPORAIREMENT DÉSACTIVÉ - en attente de migration vers API
      console.log('Gestion des utilisateurs temporairement désactivée');
      setUsers([]);
      
      // Code original commenté :
      // const allUsers = await usersDB.getAll();
      // setUsers(allUsers);
    } catch (error) {
      console.error('Erreur lors du chargement des utilisateurs:', error);
      setError('Erreur lors du chargement des utilisateurs');
    }
  };

  // Effet pour synchroniser avec les techniciens
  useEffect(() => {
    const syncInterval = setInterval(async () => {
      try {
        // TEMPORAIREMENT DÉSACTIVÉ - en attente de migration vers API
        console.log('Gestion des techniciens temporairement désactivée');
      } catch (error) {
        console.error('Error syncing users:', error);
      }
    }, 1000); // Vérifier toutes les secondes

    return () => clearInterval(syncInterval);
  }, []);

  const handleAddUser = async () => {
    // TEMPORAIREMENT DÉSACTIVÉ
    setError('Fonctionnalité temporairement désactivée - migration en cours');
    return;
    
    // Code original commenté :
    /*
    try {
      await usersDB.add(newUser);
      setOpenDialog(false);
      setNewUser({
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        role: USER_ROLES.VIEWER
      });
      loadUsers();
    } catch (error) {
      console.error('Erreur lors de l\'ajout de l\'utilisateur:', error);
    }
    */
  };

  const handleUpdateRole = async (userId, newRole) => {
    // TEMPORAIREMENT DÉSACTIVÉ
    setError('Fonctionnalité temporairement désactivée - migration en cours');
    return;
    
    // Code original commenté :
    /*
    try {
      await usersDB.update(userId, { role: newRole });
      loadUsers();
    } catch (error) {
      console.error('Erreur lors de la mise à jour du rôle:', error);
    }
    */
  };

  const handleDeleteUser = async (userId) => {
    // TEMPORAIREMENT DÉSACTIVÉ
    setError('Fonctionnalité temporairement désactivée - migration en cours');
    return;
    
    // Code original commenté :
    /*
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet utilisateur ?')) {
      try {
        await usersDB.delete(userId);
        loadUsers();
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
      }
    }
    */
  };

  const canResetPassword = (user) => {
    if (currentUser.role === USER_ROLES.SUPER_ADMIN) return true;
    if (currentUser.role === USER_ROLES.ADMIN) {
      return user.role === USER_ROLES.VIEWER && user.id !== currentUser.id;
    }
    return false;
  };

  const handleResetPassword = async (user) => {
    // TEMPORAIREMENT DÉSACTIVÉ
    setError('Fonctionnalité temporairement désactivée - migration en cours');
    return;
    
    // Code original commenté :
    /*
    try {
      await usersDB.update(user.id, { password: DEFAULT_PASSWORD });
      setError(''); // Clear any previous errors
      alert(`Mot de passe réinitialisé pour ${user.username}`);
    } catch (error) {
      console.error('Erreur lors de la réinitialisation:', error);
      setError('Erreur lors de la réinitialisation du mot de passe');
    }
    */
  };

  const confirmResetPassword = async () => {
    // TEMPORAIREMENT DÉSACTIVÉ
    setError('Fonctionnalité temporairement désactivée - migration en cours');
    return;
    
    // Code original commenté :
    /*
    try {
      const user = resetPasswordConfirmDialog.user;
      await usersDB.update(user.id, { password: DEFAULT_PASSWORD });
      setResetPasswordConfirmDialog({ open: false, user: null });
      // Afficher un message de succès temporaire
      alert(`Le mot de passe de ${user.firstName} ${user.lastName} a été réinitialisé à : ${DEFAULT_PASSWORD}`);
    } catch (error) {
      console.error('Erreur lors de la réinitialisation du mot de passe:', error);
      alert('Erreur lors de la réinitialisation du mot de passe');
    }
    */
  };

  if (!hasPermission('users:view')) {
    return (
      <Typography variant="h6" sx={{ p: 2 }}>
        Vous n'avez pas les droits nécessaires pour accéder à cette page.
      </Typography>
    );
  }

  return (
    <Box>
      <PageTitle 
        title="Gestion des droits" 
        actions={
          hasPermission('users:create') && (
            <Button
              variant="contained"
              onClick={() => setOpenDialog(true)}
            >
              Ajouter un utilisateur
            </Button>
          )
        }
      />

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nom</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Rôle</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{`${user.firstName} ${user.lastName}`}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  {hasPermission('users:edit') ? (
                    <FormControl size="small">
                      <Select
                        value={user.role}
                        onChange={(e) => handleUpdateRole(user.id, e.target.value)}
                        disabled={user.role === USER_ROLES.SUPER_ADMIN || user.id === currentUser?.id}
                      >
                        {Object.values(USER_ROLES).map((role) => (
                          <MenuItem key={role} value={role}>
                            {role}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : (
                    user.role
                  )}
                </TableCell>
                <TableCell>
                  <Stack direction="row" spacing={1}>
                    {canResetPassword(user) && (
                      <Tooltip title="Réinitialiser le mot de passe">
                        <IconButton
                          size="small"
                          onClick={() => handleResetPassword(user)}
                          color="primary"
                        >
                          <LockResetIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {hasPermission('users:delete') && 
                     user.role !== USER_ROLES.SUPER_ADMIN && 
                     user.id !== currentUser?.id && (
                      <Button
                        color="error"
                        onClick={() => handleDeleteUser(user.id)}
                        size="small"
                      >
                        Supprimer
                      </Button>
                    )}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Ajouter un utilisateur</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Prénom"
            fullWidth
            value={newUser.firstName}
            onChange={(e) => setNewUser({ ...newUser, firstName: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Nom"
            fullWidth
            value={newUser.lastName}
            onChange={(e) => setNewUser({ ...newUser, lastName: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            value={newUser.email}
            onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Mot de passe"
            type="password"
            fullWidth
            value={newUser.password}
            onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel>Rôle</InputLabel>
            <Select
              value={newUser.role}
              label="Rôle"
              onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
            >
              {Object.values(USER_ROLES)
                .filter(role => role !== USER_ROLES.SUPER_ADMIN)
                .map((role) => (
                  <MenuItem key={role} value={role}>
                    {role}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Annuler</Button>
          <Button onClick={handleAddUser} variant="contained">
            Ajouter
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={resetPasswordConfirmDialog.open}
        onClose={() => setResetPasswordConfirmDialog({ open: false, user: null })}
      >
        <DialogTitle>Confirmer la réinitialisation</DialogTitle>
        <DialogContent>
          <Typography>
            Êtes-vous sûr de vouloir réinitialiser le mot de passe de{' '}
            {resetPasswordConfirmDialog.user?.firstName} {resetPasswordConfirmDialog.user?.lastName} ?
            <br /><br />
            Le nouveau mot de passe sera : {DEFAULT_PASSWORD}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setResetPasswordConfirmDialog({ open: false, user: null })}
          >
            Annuler
          </Button>
          <Button 
            onClick={confirmResetPassword} 
            variant="contained" 
            color="primary"
          >
            Réinitialiser
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default UserRights; 